if(!customElements.get('main-blog')) {
  customElements.define('main-blog',
    class mainBlog extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.getAttribute('data-section-id');
        this.initSlider(this);
      }

      initSlider(self) {
        let sectionId = self.sectionId;
        window.swiperMainBlog = new Swiper(`.filter-main-blog-${sectionId}`, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          setWrapperSize: false,
          autoHeight: true,
          freeMode: true,
          grabCursor: true,
          mousewheel: {
            forceToAxis: true,
          },
        });
        this.scrollToSliderActive();
      }

      scrollToSliderActive() {
        let position = 0;
        let totalEl = 0;

        this.querySelector('.filter-main-blog-wrapper')
          .querySelectorAll('.item-tag-filter')
          .forEach((item, index) => {
            if (item.querySelector('.item-filter-blog-active')) {
              position = index;
            }
            totalEl = totalEl + item.offsetWidth;
          });

        window.swiperMainBlog.slideTo(position, 100, true);
      }
    }
  )
}


